module.exports = __webpack_public_path__ + "ce68cf66981ad5ab49e786026cb1fc62.png";